var _rect, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#F8F6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.035C15.75 16.1873 16.4373 15.5 17.285 15.5H21.0637C21.9115 15.5 22.5987 16.1873 22.5987 17.035V20.8137C22.5987 21.6615 21.9115 22.3487 21.0637 22.3487H17.285C16.4373 22.3487 15.75 21.6615 15.75 20.8137V17.035Z",
    fill: "url(#paint0_linear_13878_152095)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9013 26.1863C24.9013 25.3385 25.5885 24.6513 26.4363 24.6513H30.215C31.0628 24.6513 31.75 25.3385 31.75 26.1863V29.965C31.75 30.8128 31.0627 31.5 30.215 31.5H26.4363C25.5885 31.5 24.9013 30.8127 24.9013 29.965V26.1863Z",
    fill: "url(#paint1_linear_13878_152095)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 18.9244C31.75 20.8156 30.2169 22.3487 28.3256 22.3487C26.4344 22.3487 24.9013 20.8156 24.9013 18.9244C24.9013 17.0331 26.4344 15.5 28.3256 15.5C30.2169 15.5 31.75 17.0331 31.75 18.9244Z",
    fill: "url(#paint2_linear_13878_152095)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5987 28.0756C22.5987 29.9669 21.0656 31.5 19.1744 31.5C17.2831 31.5 15.75 29.9669 15.75 28.0756C15.75 26.1844 17.2831 24.6513 19.1744 24.6513C21.0656 24.6513 22.5987 26.1844 22.5987 28.0756Z",
    fill: "url(#paint3_linear_13878_152095)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13878_152095",
    x1: 19.6885,
    y1: 30.1838,
    x2: 50.2364,
    y2: -3.65078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13878_152095",
    x1: 19.6885,
    y1: 30.1838,
    x2: 50.2364,
    y2: -3.65078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13878_152095",
    x1: 19.6885,
    y1: 30.1838,
    x2: 50.2364,
    y2: -3.65078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13878_152095",
    x1: 19.6885,
    y1: 30.1838,
    x2: 50.2364,
    y2: -3.65078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.b2a992a0f6f02c62c248f99b2e2da7bc.svg";
export { ForwardRef as ReactComponent };